import { Injectable } from "@angular/core";

import { openIM } from "./intercom.utils";

@Injectable()
export class IntercomService {
  openIntercomMessenger = openIM;
}
